import { Controller } from "@hotwired/stimulus"

// Cycles Bullet Train's color scheme preference (`window.colorScheme`, the same
// one Account Details edits) through light, dark and same-as-system.
export default class extends Controller {
  static order = ["light", "dark", "system"]
  static values = {labels: Object}

  connect() {
    this.sync = this.sync.bind(this)

    window.addEventListener("color-scheme:changed", this.sync)
    // A morph refresh copies the server-rendered attributes back onto the
    // button without reconnecting this controller.
    document.addEventListener("turbo:morph", this.sync)
    this.sync()
  }

  disconnect() {
    window.removeEventListener("color-scheme:changed", this.sync)
    document.removeEventListener("turbo:morph", this.sync)
  }

  cycle() {
    if (!window.colorScheme) return

    window.colorScheme.preference = this.next
  }

  sync() {
    const label = this.labelsValue[this.state]

    this.element.dataset.colorSchemeState = this.state
    this.element.dataset.colorSchemeNext = this.next
    if (label) {
      this.element.setAttribute("aria-label", label)
      this.element.setAttribute("title", label)
    }
  }

  get state() {
    return window.colorScheme?.preference || "system"
  }

  get next() {
    const order = this.constructor.order
    return order[(order.indexOf(this.state) + 1) % order.length]
  }
}
